import React, { createContext, useContext, useMemo, useState, useEffect } from 'react'

const AuthCtx = createContext(null)

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null)       // { id, name, roles: ['admin','manager'], token }
  const isAuthenticated = !!user?.token

  useEffect(() => {
    // пример: восстановить из localStorage
    const raw = localStorage.getItem('auth')
    if (raw) setUser(JSON.parse(raw))
  }, [])

  const login = (u) => {
    setUser(u)
    localStorage.setItem('auth', JSON.stringify(u))
  }

  const logout = () => {
    setUser(null)
    localStorage.removeItem('auth')
  }

  const hasRole = (role) => user?.roles?.includes(role)
  const hasAny  = (roles=[]) => roles.length === 0 || roles.some(hasRole)
  const hasAll  = (roles=[]) => roles.every(hasRole)

  const value = useMemo(() => ({
    user, isAuthenticated, login, logout, hasRole, hasAny, hasAll
  }), [user])

  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>
}

export function useAuth() {
  return useContext(AuthCtx)
}
